const ABTestsReducerInitialState = [
  'DGS-2532-Search-results-redesign-AB-test' // AB test redesigning search results with list/grid options
];

export default ABTestsReducerInitialState;
